import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeapRoutingModule } from './leap-routing.module';
import { LeapWelcomeComponent } from './onboarding/welcome/welcome.component';
import { LeapConfirmationComponent } from './onboarding/confirmation/confirmation.component';
import { UiModule } from 'src/app/ui/ui.module';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { LeapEntryPointComponent } from './entry-point/entry-point.component';
import { BusinessSettingsRedirectDialogComponent } from './business-settings-redirect-dialog/business-settings-redirect-dialog.component';
import { AddLawyerClerkToLeapMatterUnsuccessfulComponent } from './modals/add-lawyer-clerk-to-leap-matter-unsuccessful/add-lawyer-clerk-to-leap-matter-unsuccessful.component';
import { CannotAddLawyerClerkToMatterComponent } from './modals/cannot-add-lawyer-clerk-to-matter/cannot-add-lawyer-clerk-to-matter.component';
import { LawyerMismatchNotificationComponent } from './modals/lawyer-mismatch-notification/lawyer-mismatch-notification.component';
import { ResolveLawyerClerkMismatchComponent } from './modals/resolve-lawyer-clerk-mismatch/resolve-lawyer-clerk-mismatch.component';
import { VideoIntroComponent } from './onboarding/video-intro/video-intro.component';
import { BillingSetupComponent } from './billing-setup/billing-setup.component';
import { ContactAdminComponent } from './billing-setup/contact-admin/contact-admin.component';
import { StripeSetupComponent } from './billing-setup/stripe-setup/stripe-setup.component';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { UpdateLeapReminderComponent } from './onboarding/update-leap-reminder/update-leap-reminder.component';
import { provideLeapOnboardingService } from './leap-onboarding.providers';

@NgModule({
	declarations: [
		LeapWelcomeComponent,
		LeapConfirmationComponent,
		LeapEntryPointComponent,
		BusinessSettingsRedirectDialogComponent,
		AddLawyerClerkToLeapMatterUnsuccessfulComponent,
		ResolveLawyerClerkMismatchComponent,
		LawyerMismatchNotificationComponent,
		CannotAddLawyerClerkToMatterComponent,
		VideoIntroComponent,
		BillingSetupComponent,
		ContactAdminComponent,
		StripeSetupComponent,
		UpdateLeapReminderComponent,
	],
	imports: [
		CommonModule,
		CoreModule,
		LeapRoutingModule,
		UiModule,
		AtomicModule,
		MatTableModule,
		FormsModule,
		ReactiveFormsModule,
	],
	providers: [...provideLeapOnboardingService()],
	exports: [
		AddLawyerClerkToLeapMatterUnsuccessfulComponent,
		ResolveLawyerClerkMismatchComponent,
		LawyerMismatchNotificationComponent,
		CannotAddLawyerClerkToMatterComponent,
	],
})
export class LeapModule {}
